import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const Testimonials = () => {
  const { t } = useLanguage();
  return (
    <section id="reviews" data-testid="testimonials-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl"
        >
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-600" data-testid="testimonials-eyebrow">
            {t.testimonials.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
            {t.testimonials.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">{t.testimonials.subtitle}</p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {t.testimonials.items.map((tm, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="bg-[#F4F7F9] p-7 lg:p-8 border-l-4 border-cyan-500 flex flex-col h-full relative hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={28} className="text-cyan-500/30 absolute top-5 right-5" />
              <div className="flex gap-0.5" data-testid={`testimonial-stars-${i}`}>
                {[...Array(5)].map((_, k) => (
                  <Star key={k} size={16} className="fill-amber-400 text-amber-400" />
                ))}
              </div>
              <blockquote className="mt-5 text-sm sm:text-base text-slate-700 leading-relaxed flex-1">
                „{tm.quote}“
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-slate-200">
                <div className="font-display font-bold text-slate-900">{tm.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">{tm.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
